<template>
    <div class="text-center">
        <h2 class="p-b-20">绑定平台账号</h2>
        <Alert type="error" show-icon v-show="pageView.showMessage">{{pageView.message}}</Alert>
        <Form ref="formBindUser" :model="formBindUserValidate" :rules="ruleBindUserValidate" :label-width="80">
            <FormItem label="F码" prop="fcode">
                <i-input v-model="formBindUserValidate.fcode" placeholder="请输入平台提供的F码"></i-input>
            </FormItem>
            <FormItem label="">
                <Checkbox v-model="isChecked">我同意</Checkbox><a @click="showModalAgreement=true">《使用协议》</a>
            </FormItem>
            <FormItem>
                <Button type="error" :disabled="!isChecked" long size="large" @click="handleSubmit('formBindUser')">绑定并登录</Button>
            </FormItem>
        </Form>
         <Modal v-model="showModalAgreement" width="1200" :closable="false" :mask-closable="false">
          <agreement/>
          <div slot="footer" class="text-center">
            <Button type="warning" size="small" @click="showModalAgreement=false">我已阅读，并关闭窗口</Button>
          </div>
        </Modal>
    </div>
</template>

<script>
import agreement from '@/views/search/components/agreement'

import { bindfcode } from '@/api/loginV2'
// const CryptoJS = require('crypto-js')

export default {
  components: {
    agreement
  },
  name: 'binduser',
  props: {
    wxUid: String,
    appid: String
  },
  data () {
    return {
      showModalAgreement: false,
      pageView: {
        showMessage: false,
        message: ''
      },
      formBindUserValidate: {
        fcode: ''
      },
      ruleBindUserValidate: {
        fcode: [
          { required: true, message: '请输入F码', trigger: 'blur' }
        ]
      },
      isChecked: true
    }
  },
  methods: {
    handleSubmit (name) {
      const that = this
      if (!that.isChecked) {
        that.pageView.showMessage = true
        that.pageView.message = '请同意平台协议'
        return
      } else {
        that.pageView.showMessage = false
      }

      that.$refs[name].validate((valid) => {
        if (valid) {
          // 开始绑定code和账号密码， 如果成功自动登录
          bindfcode(that.formBindUserValidate).then(response => {
            that.$emit('bindFinished')
            // that.$parent.bindFinished()
          })
        }
      })
    }
  }
}
</script>
